/**
 * Block is used on framework/vc-elements/care-services/block-care-services-content-block.php
 *
 * @returns {{isExpanded: boolean, trimmedContent: string, buttonVisible: boolean, expandContent(): void, updateContent(): void, readMoreButtonDisabled: boolean, content: string, originalContent: string}}
 */
export default () => ({

    isExpanded: false,
    buttonVisible: false,
    readMoreButtonDisabled: false,

    content: '',
    originalContent: '',
    trimmedContent: '',

    updateContent() {
        if (!this.readMoreButtonDisabled) {
            let newContent = this.originalContent;
            let trimmedString = newContent.substring(0, 500);

            this.trimmedContent = trimmedString + '...';
            this.content = this.trimmedContent;

            this.buttonVisible = true;
        } else {
            this.content = this.originalContent;
        }
    },

    expandContent() {
        this.isExpanded = !this.isExpanded;

        if (this.isExpanded) {
            this.content = this.originalContent;
        } else {
            this.content = this.trimmedContent;
        }
    }
})